
























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { listDevice, getEquipment } from "@/api/equipment/device";
import { dateFormat } from "@/utils/comparsion";
import {
  submit,
  saveAnalysis,
  distributeAnalysis,
  getList
} from "@/api/project/analysis";
import { getProject } from "@/api/project/design";
import { treeselect } from "@/api/system/dept";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { isExistLength } from "@/utils/utils";
@Component({
  components: {
    Treeselect
  }
})
export default class Device extends Vue {
  public projectList = [];
  public projectId = "";
  public list = [];
  public deptOptions = [];
  public distributDialog = false;
  private filterText = null;
  public queryParams = {
    params: undefined,
    pageNum: 1,
    pageSize: 10,
    projId:''
  };
  defaultProps = {
    children: "designVoList",
    label: "projName"
  };
  private loading = false;
  public ruleForm = {
    issue: "",
    parentId: null
  };
  public rules = {
    parentId: [{ required: true, message: "请选择所属人员", trigger: "blur" }],
    issue: [{ required: true, message: "请输入处理意见", trigger: "blur" }]
  };
  public selectList = [];
  public total = 0;
  public rowList = {};
  public created() {
    this.getProjectList();
  }
  @Watch("filterText")
  getFilterText(val) {
    this.$refs.tree.filter(val);
  }
  // 获取项目列表
  public getProjectList() {
    getProject({ userId: 1 }).then(res => {
      this.projectList = res.data;
      if(isExistLength(res.data)) {
        this.projectId = res.data[0].projId;
        this.$nextTick(function() {
          this.$refs.tree.setCurrentKey(this.projectId);
        });
        this.getList();
      }
      
    });
  }
  public getList() {
    this.loading = true;
    this.queryParams.projId = this.projectId;
    this.list = [];
    this.total = 0;
    getList(this.queryParams).then(res => {
      this.loading = false;
      if(res.code === 200) {
        this.list = res.rows;
        this.total = res.total;
      } else {
        this.$message.error(res.msg);
      }
      
    });
  }
  public onSubmit() {
    this.queryParams.pageNum = 1;
    if (this.selectList.length === 0) {
      this.$message.error("请选择您要提交的方案");
    } else {
      submit(this.selectList).then(res => {
        this.getList();
      });
    }
  }
  public getTreeselect() {
    treeselect().then(response => {
      this.deptOptions = response.data;
    });
  }
  public save() {
    if (this.selectList.length === 0) {
      this.$message.error("请选择您要保存的方案");
    } else {
      saveAnalysis(this.selectList).then(res => {
        if (res.code === 200) {
          this.$message.success("保存成功!");
          this.getList(this.projectId);
        }
      });
    }
  }
  public distribut() {
    this.distributDialog = true;
    this.getTreeselect();
  }
  public resetForm(formName) {
    this.$refs[formName].resetFields();
    this.distributDialog = false;
  }
  public submitForm(formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        // this.distributDialog = false;
        distributeAnalysis(this.ruleForm).then(res => {
          this.distributDialog = false;
        });
      } else {
        return false;
      }
    });
  }
  public handleSelectionChange(val) {
    this.selectList = val;
  }
  public handleNodeClick(val: object) {
    this.projectId = Number(val.projId);
    this.queryParams.pageNum = 1;
    this.getList();
  }
  private filterNode(value, data) {
    if (!value) return true;
    return data.projName.indexOf(value) !== -1;
  }
}
